const surcharge_title = (state = null, action: any) => {
	switch(action.type) {
		case 'SET_SURCHARGE_TITLE':
            return action.payload;
            break;
        default: 
        	return state;
        	break;
	}
}

export default surcharge_title;